<div class="layout-chooser">
  <button
    type="button"
    class="layout-chooser-trigger"
    [class.is-open]="isPopoverOpen"
    (click)="layoutPopover.toggle($event)"
    pTooltip="Change layout"
    tooltipPosition="left"
    aria-label="Change layout"
    aria-haspopup="dialog"
    [attr.aria-expanded]="isPopoverOpen">
    <i class="pi pi-th-large" aria-hidden="true"></i>
  </button>

  <p-popover
    #layoutPopover
    [dismissable]="true"
    styleClass="layout-chooser-popover"
    (onShow)="onPopoverShow()"
    (onHide)="onPopoverHide()">
    <div class="layout-chooser-panel">
      <div class="layout-chooser-panel__header">
        <span class="layout-chooser-panel__title">Dashboard layout</span>
      </div>

      <div class="layout-chooser-options" role="radiogroup" aria-label="Dashboard layout presets">
        <button
          *ngFor="let option of layoutOptions; trackBy: trackByPresetId"
          type="button"
          class="layout-card"
          [class.layout-card--selected]="isSelected(option.id)"
          [attr.aria-checked]="isSelected(option.id)"
          [attr.aria-label]="option.label"
          role="radio"
          (click)="selectPreset(option.id)">
          <span class="layout-card__diagram" aria-hidden="true">
            <span
              class="layout-card__top-row"
              [style.grid-template-columns]="'repeat(' + option.panes.length + ', minmax(0, 1fr))'">
              <span
                *ngFor="let pane of option.panes"
                class="layout-card__pane"
                [attr.data-pane]="pane"
                [attr.title]="paneAriaLabels[pane]">
                {{ paneShortLabels[pane] }}
              </span>
            </span>
            <span class="layout-card__taskbank">TaskBank</span>
          </span>

        </button>
      </div>
    </div>
  </p-popover>
</div>
